import { Button } from "@heroui/react";
import { useNavigate } from "react-router-dom";
import { Helmet, HelmetProvider } from "react-helmet-async";
import { useTranslation } from "react-i18next";

export default function UnAuthorizedPage() {
  const navigate = useNavigate();
  const { t } = useTranslation();

  return (
    <div className="flex min-h-screen items-center justify-center bg-gray-50">
      <HelmetProvider>
        <Helmet>
          <title>{t("access_denied_title")}</title>
        </Helmet>
      </HelmetProvider>

      <div className="text-center px-6">
        <div className="mb-6">
          <span className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-red-100">
            <svg
              className="w-8 h-8 text-red-600"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"
              />
            </svg>
          </span>
        </div>

        <h1 className="text-2xl font-semibold text-gray-900 mb-2">
          {t("access_denied")}
        </h1>

        <p className="text-gray-600 mb-8 max-w-md">
          {t("access_denied_message")}
        </p>

        <Button color="primary" onPress={() => navigate("/orders")}>
          {t("back_to_home")}
        </Button>
      </div>
    </div>
  );
}
